import { OrderType } from 'src/app/enums/order-type.enum';

export class FetchAoeQuestions {
  public static readonly type = '[AoeQuestions] Fetch Aoe Questions';

  constructor(
    public readonly orderId: number,
    public readonly orderType: OrderType | null
  ) {}
}

export class FetchAoeQuestionsIfEmpty {
  public static readonly type = '[AoeQuestions] Fetch Aoe Questions If it is not loaded';

  constructor(
    public readonly orderId: number,
    public readonly orderType: OrderType | null
  ) {}
}
